/** @jsxImportSource @emotion/react */
import { Box, Button, css } from '@mui/material'
import { PUBLIC_ASSETS_BASE_URL } from '@app/app-constants'
import { propertySearchContainer } from '@app/components/Property/components/PropertyLandingPage.style'
import { SplashPage } from '@app/components/ui/SplashPage/SplashPage'
import { SplashBanner } from '@app/components/ui/SplashPage/SplashPageBanner'
import AccessNavbar from './AccessNavbar'

const accessBannerImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_access_hero.svg`
const accessLogoImg = `${PUBLIC_ASSETS_BASE_URL}/images/shared/rex_access_logo.svg`

export const AccessLandingPage = () => {
  return (
    <>
      <AccessNavbar />
      <SplashPage>
        <SplashPage.Hero>
          <SplashBanner testId="property-splash-page-banner">
            <SplashBanner.Wrapper>
              <SplashBanner.LeftColumn>
                <SplashBanner.Logo src={accessLogoImg} alt="Access - Resilience Explorer" />
                <SplashBanner.Headline>
                  Explore access to amenities — a key component of community resilience.{' '}
                </SplashBanner.Headline>
              </SplashBanner.LeftColumn>
              <SplashBanner.RightColumn>
                <SplashBanner.Image src={accessBannerImg} alt="Access - Hero" />
              </SplashBanner.RightColumn>
            </SplashBanner.Wrapper>
          </SplashBanner>
        </SplashPage.Hero>
        <SplashPage.Content>
          <Box css={propertySearchContainer}>
            <Box css={accessButtonWrapper}>
              <Button
                component="a"
                href="https://access.resilience-explorer.com/"
                target="_blank"
                rel="noopener noreferrer"
                variant="contained"
                color="primary"
              >
                Go To Access
              </Button>
            </Box>
          </Box>
        </SplashPage.Content>
      </SplashPage>
    </>
  )
}

export const accessButtonWrapper = css`
  display: flex;
  gap: 16px;
  margin-top: 24px;
`
